import React from 'react';
import PropTypes from 'prop-types';

const OtherSportPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M1.705 6.06a1.06 1.06 0 0 1 1.407-1.001l28.175 9.762a1.06 1.06 0 0 1 0 2.003L3.112 26.587a1.061 1.061 0 0 1-1.407-1.002v-1.327l-.634.634a.266.266 0 0 1-.375 0l-.619-.618a.267.267 0 0 1 0-.376l1.074-1.073-1.074-1.074a.266.266 0 0 1 0-.375l.619-.619a.266.266 0 0 1 .375 0l.634.634V10.002l-.634.634a.266.266 0 0 1-.375 0l-.619-.618a.266.266 0 0 1 0-.375l1.074-1.074L.077 7.495a.265.265 0 0 1 0-.374l.619-.619a.266.266 0 0 1 .375 0l.634.634V6.06zm1.713 18.215a.532.532 0 0 0 .674.329l24.548-8.477a.266.266 0 0 0 0-.502L4.092 7.148a.53.53 0 0 0-.703.502v16.453c0 .058.01.117.029.172zM4.17 9.349a.53.53 0 1 1 1.06 0v12.945a.53.53 0 1 1-1.06 0V9.349zm6.427 2.791a.45.45 0 0 1 .807 0l.813 1.65a.45.45 0 0 0 .34.246l1.821.265a.45.45 0 0 1 .249.767l-1.318 1.285a.446.446 0 0 0-.129.398l.311 1.814a.449.449 0 0 1-.653.474l-1.628-.857a.456.456 0 0 0-.419 0l-1.629.857a.45.45 0 0 1-.653-.474l.311-1.814a.447.447 0 0 0-.13-.398l-1.317-1.285a.45.45 0 0 1 .25-.767l1.821-.265a.45.45 0 0 0 .338-.246l.815-1.65z"
    />
  );
};

OtherSportPath.propTypes = {
  fill: PropTypes.string,
};

export default OtherSportPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/other-sport.jsx